export class TasksList {
  page_number = 1;
  per_page = 10;
}
